import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../Components/Header'
import { Container } from '@material-ui/core';
import Footer from '../Components/Footer'
import './style.css'

const Privacy = () => {
    return (
        <div>
            <Header />
            <Container className="margin-b">
                <div className="footer-pages-header">
                    <div className="dark-line"></div>
                    <h1 className="title-style">Privacy Policy</h1>
                </div>
                <section className="section-styles">
                    <h4>SECTION 1 - WHAT DO WE DO WITH YOUR INFORMATION?</h4>
                    <p>
                        When you submit your application, the application form will be reviewed by the College staff for accuracy and for the selection process.
                    </p>
                </section>
                <section className="section-styles">
                    <h4>SECTION 2 -CONSENT</h4>
                    <p>
                        How do you get my consent?
                    </p>
                    <p>
                        When you provide us with personal information via the application form, we imply that you consent to our collecting it and using it for that specific reason only.
                        If we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your expressed consent, or provide you with an opportunity to say no.
                    </p>
                    <p>
                        How do I withdraw my consent?
                    </p>
                    <p>
                        If after you opt-in, you change your mind, you may withdraw your consent for us to contact you, for the continued collection, use or disclosure of your information, at anytime, by contacting us at <b>admission@vjcet.org</b> or mailing us at:
                    </p>
                    <ul>
                        <li>Viswajyothi College of Engineering and Technology,</li>
                        <li>Vazhakulam P O,</li>
                        <li>Muvattupuzha,</li>
                        <li>Ernakulam 686 670</li>
                    </ul>
                </section>
                <section className="section-styles">
                    <h4>SECTION 3 - DISCLOSURE</h4>
                    <p>
                        We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service.

                    </p>
                </section>
                <section className="section-styles">
                    <h4>SECTION 4 - PAYMENT</h4>
                    <p>
                        We use Razorpay for processing payments. We/Razorpay do not store your card data on their servers. The data is encrypted through the Payment Card Industry Data Security Standard (PCI-DSS) when processing payment. Your purchase transaction data is only used as long as is necessary to complete your purchase transaction. After that is complete, your purchase transaction information is not saved.
                        Our payment gateway adheres to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover.
                        PCI-DSS requirements help ensure the secure handling of credit card information by our site and its service providers.
                    For more insight, you may also want to read terms and conditions of razorpay on <a href="https://razorpay.com">https://razorpay.com</a>
                    </p>
                </section>
                <section className="section-styles">
                    <h4>SECTION 5 - THIRD-PARTY SERVICES</h4>
                    <p>
                        In general, the third-party providers used by us will only collect, use and disclose your information to the extent necessary to allow them to perform the services they provide to us.
                        However, certain third-party service providers, such as payment gateways and other payment transaction processors, have their own privacy policies in respect to the information we are required to provide to them for your purchase-related transactions.
                        For these providers, we recommend that you read their privacy policies so you can understand the manner in which your personal information will be handled by these providers.

                    </p>
                    <p>
                        In particular, remember that certain providers may be located in or have facilities that are located a different jurisdiction than either you or us. So if you elect to proceed with a transaction that involves the services of a third-party service provider, then your information may become subject to the laws of the jurisdiction(s) in which that service provider or its facilities are located.
                    </p>
                    <p>
                        Once you leave our website or are redirected to a third-party website or application, you are no longer governed by this Privacy Policy or our website’s Terms of Service.Links -When you click on links on our website, they may direct you away from our site. We are not responsible for the privacy practices of other sites and encourage you to read their privacy statements.

                    </p>
                </section>
                <section className="section-styles">
                    <h4>SECTION 6 - SECURITY</h4>
                    <p>
                        To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed.
                    </p>
                </section>
                <section className="section-styles">
                    <h4>SECTION 7 - COOKIES</h4>
                    <p>
                        We use cookies to maintain session of your user. It is not used to personally identify you on other websites.
                    </p>
                </section>
                <section className="section-styles">
                    <h4>SECTION 8 - AGE OF CONSENT</h4>
                    <p>
                        By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.

                    </p>
                </section>
                <section className="section-styles">
                    <h4>SECTION 9 - CHANGES TO THIS PRIVACY POLICY</h4>
                    <p>
                        To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed.
                    </p>
                </section>
                <section className="section-styles">
                    <h4>QUESTIONS AND CONTACT INFORMATION</h4>
                    <p>
                        If you would like to: access, correct, amend or delete any personal information we have about you, register a complaint, or simply want more information contact our Privacy Compliance Officer at <b>admission@vjcet.org </b>or mailing us at:
                    </p>
                    <ul>
                        <li>Viswajyothi College of Engineering and Technology,</li>
                        <li>Vazhakulam P O,</li>
                        <li>Muvattupuzha,</li>
                        <li>Ernakulam 686 670</li>
                    </ul>
                </section>

            </Container>
            <Footer />


        </div>
    )
}

export default Privacy;